<template>
    <div class="col-12 text-dark">
        <div class="col-12 bb-1 bb-dark pb-2 d-flex justify-content-between align-items-end">
            <p class="w-fc fw-bold text-left">{{ item.pregunta }}</p>
            <div class="btn btn-secondary2 cursor-pointer btn-rounded" @click="() => { show = !show }">
                <i class="fa-solid fa-plus"></i>
            </div>
        </div>
        <transition name="fade">
            <p v-if="show && item.id != 2" class="w-full mt-3 font16 textSecondary animate__animated animate__fadeInUp">
                {{ item.respuesta }}</p>
        </transition>
        <transition name="fade">
            <div v-if="show && item.id == 2"
                class="w-full mt-3 font16 textSecondary animate__animated animate__fadeInUp">
                <p class="mb-2">Para conocer el monto al que puedes acceder con tu crédito Infonavit, ingresa a Mi
                    Cuenta
                    Infonavit. Ahí podrás obtener tu precalificación, que incluye:</p>
                <ul>
                    <li>Monto autorizado</li>
                    <li>Plazo</li>
                    <li>Descuento mensual</li>
                    <li>Aportaciones patronales</li>
                    <li>Tabla de amortización</li>
                </ul>
                <p>Si necesitas ayuda para consultar tu precalificación, contáctanos y con gusto te asesoramos. Con esta
                    información, daremos inicio al proceso para hacer realidad el proyecto de vivienda que tienes en
                    mente.
                    En Friax, somos una constructora autorizada por Infonavit, lista para guiarte en cada paso.
                    ¡Contáctanos
                    y comienza hoy mismo!</p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    props: {
        item: {
            type: Object,
        },
    },
    data() {
        return {
            show: false
        }
    }
};
</script>

<style scoped></style>